export default "__VITE_ASSET__B4Gb5h9A__"